<template>
  <gj-modal
      :visible.sync="modalVisible"
      :contentStyle="{'height': '100%', 'display': 'flex', 'flex-direction': 'column'}"
  >
    <template #header>导入记录</template>
    <template #content>
      <app-filter-group class="gj-mb10" :isBr="false" :reset="false" @query="$gjNoticeQuery">
        <gj-country-server-select
            v-model="marketAndCountry"
        ></gj-country-server-select>
        <gj-select
            v-model="status"
            :options="statusOption"
            placeholder="请选择状态"
            width="150px"
        >
        </gj-select>
        <gj-select
            v-model="reportType"
            :options="[
              ...orderTypeOption
            ]"
            placeholder="请选择报表类型"
            width="130px"
        ></gj-select>
        <gj-select
            v-model="op"
            placeholder="请选择操作路径"
            :options="operationPathOption"
            width="150px"
        ></gj-select>
        <gj-date-picker
            v-model="date"
            type="daterange"
        ></gj-date-picker>
      </app-filter-group>
      <div style="flex: 1; overflow: auto">
        <gj-table
            :data="data"
            adaptParent
            :columns="columns"
            :offset-height="6"
            :pagination="pagination"
            :loading="loading"
            :index="false"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
        >
        <template v-slot:op="{row}">
            <div>
              <gj-button :disabled="row.attachmentId === null || row.attachmentId === '0'" type="text" @click="download(row.attachmentId)">下载</gj-button>
             <gj-button v-if="$permission('dateRangeReportsLog:revoke') && row.status === 0" type="text" @click="operation(row)">撤销导入</gj-button>
            </div>
        </template>
        </gj-table>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin} from "../../../../../../minxins";
  import {mapGetters} from "vuex";
  import {dateRangeReportLogPage, undoImport} from "../../../../../../api/finance";
  import {isMeaningful} from "../../../../../../utils/common";
  import {downloadAttFile} from "../../../../../../api/common";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {orderTypeOption} from "../../../../../../utils/options";

  const operationPathOption = [
    {id: '0', text: '定时任务'},
    {id: '1', text: '云插件任务'},
    {id: '2', text: '手动导入'},
  ];

  const statusOption = [
    {id: 0, text: '成功'},
    {id: 1, text: '失败'},
    {id: 2,  text:'报表无数据'},
    {id: 3, text: '已撤销'},
  ];

  export default {
    name: "settlement-import-record",
    mixins: [modalMixIn, queryMixin],
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    data() {
      return {
        marketAndCountry: null,
        status: null,
        reportType: null,
        op: null,
        date: [],
        data: [],
        operationPathOption: operationPathOption,
        statusOption: statusOption,
        orderTypeOption: orderTypeOption,
        columns: [
          {id: 'market', header: '店铺/国家', field: 'option:marketId', minWidth: '120px', default: true, sortable: true, options: () => this.marketOption, sortBy: 'marketId'},
          {id: 'reportName', header: '报表名称', field: 'reportName', minWidth: '150px', default: true, overflowLine: 2, sortable: true},
          {id: 'orderType', header: '报表类型', field: 'option:orderType', minWidth: '100px', default: true, sortable: true, options: orderTypeOption, sortBy: 'orderType'},
          {id: 'requestStartDate', header: '日期范围', field: 'requestStartDate', minWidth: '180px', default: true, sortable: true,},
          {id: 'status', header: '状态', field: 'option:status', minWidth: '100px', default: true, sortable: true, options: statusOption, sortBy: 'status'},
          {id: 'operationPath', header: '操作路径', field: 'option:operationPath', minWidth: '100px', default: true, sortable: true, options: operationPathOption, sortBy: 'operationPath'},
          {id: 'createUser', header: '操作用户', field: 'createUser', minWidth: '80px', default: true, sortable: true,},
          {id: 'createTime', header: '记录时间', field: 'createTime', minWidth: '130px', default: true, sortable: true,},
          {id: 'op', header: '操作', field: 'slot:op', minWidth: '130px', default: true,fixed: 'right'},
        ],
      }
    },
    methods: {
      $gjQuery() {
        this.loading = true;
        dateRangeReportLogPage({
          model: {
            marketIds: isMeaningful(this.marketAndCountry) ? this.marketAndCountry.marketIds : [],
            countryIds: isMeaningful(this.marketAndCountry) ? this.marketAndCountry.countryIds : [],
            status: this.status,
            orderType: this.reportType,
            operationPath: this.op,
            requestStartDate: isMeaningful(this.date) ? convertToDate(this.date[0]) : null,
            requestEndDate: isMeaningful(this.date) ? convertToDate(this.date[1]) : null,
          },
          ...this.queryPagination,
          ...this.querySort,
        }).then((data) => {
          this.data = data.records;
          this.pagination = this.getPagination(data);
        }).complete(() => this.loading = false)
      },
      operation(row){
        const vm = this;
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            content: `撤销导入后不可恢复，确认要撤销导入吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm() {
              modal.confirmLoading = true;
              const params = [];
              params.push(row.id);
              undoImport(params).then(response => {
                if (response.isSuccess) {
                  vm.$message.success("操作成功");
                  modal.$gjDestroy();
                  vm.$gjQuery();
                } else {
                  this.$message.success(response.msg)
                }
              }).complete(() => modal.confirmLoading = false)
            }
          },
        });
      },
      download(attId){
      downloadAttFile(attId);
      }
    }
  }
</script>

<style scoped>

</style>
